import Sortable from 'sortablejs';

window.initSortable = function(container) {
	if (!container) return;
	if (container._sortable) {
		container._sortable.destroy();
	}

	container._sortable = Sortable.create(container, {
		animation: 150,
		delay: 150,
		delayOnTouchOnly: true,
		ghostClass: 'opacity-40',
		chosenClass: 'scale-[1.01]',
		filter: 'button, form, input, textarea, a',
		preventOnFilter: false,

		onEnd(evt) {
			const taskId = evt.item?.dataset?.taskId;
			if (!taskId || evt.oldIndex === evt.newIndex) return;

			const prev = evt.item.previousElementSibling;
			const next = evt.item.nextElementSibling;

			let targetId = '';
			let placement = 'after';

			if (prev && prev.dataset && prev.dataset.taskId) {
				targetId = prev.dataset.taskId;
				placement = 'after';
			} else if (next && next.dataset && next.dataset.taskId) {
				targetId = next.dataset.taskId;
				placement = 'before';
			}

			if (!targetId) return;

			const params = new URLSearchParams(window.location.search);
			const activeListId = params.get('list') || '';
			const statusFilter = params.get('status') || '';
			const assigneeFilter = params.get('assignee') || '';

			if (window.htmx) {
				window.htmx.ajax('POST', `/tasks/${taskId}/reorder`, {
					values: {
						target_id: targetId,
						placement: placement,
						active_list_id: activeListId,
						status: statusFilter,
						assignee: assigneeFilter,
					},
					target: '#task-stream',
					swap: 'outerMorph',
				});
			}
		},
	});
};

document.addEventListener('alpine:init', () => {
	Alpine.data('workspacePage', (cfg = {}) => ({
		isWorkspaceSheetOpen: false,
		isListsSheetOpen: false,
		isMembersSheetOpen: false,
		isNewListSheetOpen: false,
		isTaskSheetOpen: false,
		isSearchVisible: false,
		searchQuery: '',

		statusFilter: cfg.statusFilter || 'todo',
		activeWsId: cfg.activeWsId || '',
		activeListId: cfg.activeListId || '',
		totalCount: cfg.totalCount || 0,
		todoCount: cfg.todoCount || 0,
		inProgressCount: cfg.inProgressCount || 0,
		doneCount: cfg.doneCount || 0,

		// Bulk select state
		isSelectMode: false,
		selectedTasks: [],
		bulkAction: null,
		targetMoveListId: '',
		confirmModalOpen: false,
		confirmModalTitle: '',
		confirmModalDesc: '',

		toggleSelectMode() {
			this.isSelectMode = !this.isSelectMode;
			if (!this.isSelectMode) {
				this.clearSelection();
			}
		},

		isTaskSelected(id) {
			return this.selectedTasks.includes(id);
		},

		toggleTaskSelect(id) {
			const idx = this.selectedTasks.indexOf(id);
			if (idx >= 0) {
				this.selectedTasks.splice(idx, 1);
			} else {
				this.selectedTasks.push(id);
			}
		},

		selectAll() {
			const stream = document.getElementById('task-stream');
			if (!stream) return;
			const items = Array.from(stream.querySelectorAll('[data-siro-el=TaskItem]'));
			this.selectedTasks = items
				.filter(el => this.taskMatches(el))
				.map(el => el.getAttribute('data-task-id'))
				.filter(Boolean);
		},

		clearSelection() {
			this.selectedTasks = [];
			this.bulkAction = null;
			this.targetMoveListId = '';
		},

		openBulkConfirm(action) {
			if (!this.selectedTasks.length) return;
			this.bulkAction = action;
			const count = this.selectedTasks.length;
			const itemLabel = count === 1 ? 'task' : 'tasks';

			if (action === 'complete') {
				this.confirmModalTitle = `Mark ${count} ${itemLabel} as Done?`;
				this.confirmModalDesc = `Are you sure you want to mark ${count} selected ${itemLabel} as completed?`;
			} else if (action === 'archive') {
				this.confirmModalTitle = `Archive ${count} ${itemLabel}?`;
				this.confirmModalDesc = `Are you sure you want to archive ${count} selected ${itemLabel}? They will be removed from your active workspace.`;
			} else if (action === 'move') {
				if (!this.targetMoveListId) return;
				this.confirmModalTitle = `Move ${count} ${itemLabel}?`;
				this.confirmModalDesc = `Are you sure you want to move ${count} selected ${itemLabel} to the chosen list?`;
			} else if (action === 'move_top') {
				this.confirmModalTitle = `Move ${count} ${itemLabel} to Top?`;
				this.confirmModalDesc = `Are you sure you want to move ${count} selected ${itemLabel} to the top of their respective lists?`;
			} else if (action === 'move_bottom') {
				this.confirmModalTitle = `Move ${count} ${itemLabel} to Bottom?`;
				this.confirmModalDesc = `Are you sure you want to move ${count} selected ${itemLabel} to the bottom of their respective lists?`;
			}
			this.confirmModalOpen = true;
		},

		executeBulkAction() {
			this.confirmModalOpen = false;
			if (!this.selectedTasks.length || !this.bulkAction) return;

			const values = {
				action: this.bulkAction,
				task_ids: this.selectedTasks.join(','),
				target_list_id: this.targetMoveListId || '',
				active_list_id: this.activeListId || '',
				status: this.statusFilter || '',
				q: this.searchQuery || '',
			};

			if (window.htmx) {
				window.htmx.ajax('POST', `/ws/${this.activeWsId}/tasks/bulk`, {
					values: values,
					target: '#task-stream',
					swap: 'outerMorph',
				}).then(() => {
					this.clearSelection();
					this.isSelectMode = false;
					this.targetMoveListId = '';
				});
			}
		},

		init() {
			this.syncCounts();
			document.body.addEventListener('htmx:afterSettle', () => {
				this.syncCounts();
			});
			window.addEventListener('countsUpdated', (evt) => {
				const d = evt.detail;
				if (d) {
					if (typeof d.total === 'number') this.totalCount = d.total;
					if (typeof d.todo === 'number') this.todoCount = d.todo;
					if (typeof d.in_progress === 'number') this.inProgressCount = d.in_progress;
					if (typeof d.done === 'number') this.doneCount = d.done;
				}
			});
		},

		syncCounts() {
			const stream = document.getElementById('task-stream');
			if (!stream) return;
			const items = Array.from(stream.querySelectorAll('[data-siro-el=TaskItem]'));

			if (this.statusFilter === 'all' || !this.statusFilter) {
				this.totalCount = items.length;
				this.doneCount = items.filter(el => el.getAttribute('data-siro-status') === 'completed').length;
				this.inProgressCount = items.filter(el => el.getAttribute('data-siro-status') === 'in_progress').length;
				this.todoCount = items.filter(el => el.getAttribute('data-siro-status') === 'todo').length;
			}
		},

		taskMatches(el) {
			const q = (this.searchQuery || '').trim().toLowerCase();
			if (!q) return true;
			const title = el.querySelector('[data-siro-el=TaskTitle]');
			return !!(title && title.textContent.toLowerCase().includes(q));
		},

		hasMatchingTasks() {
			return Array.from(document.querySelectorAll('[data-siro-el=TaskItem]'))
				.some((el) => this.taskMatches(el));
		},
	}));

	Alpine.data('myTasksPage', (cfg = {}) => ({
		isSearchVisible: !!cfg.isSearchVisible,
		isTaskSheetOpen: false,
		showCompleted: true,
		searchQuery: cfg.searchQuery || '',

		taskMatches(el) {
			const q = (this.searchQuery || '').trim().toLowerCase();
			if (!q) return true;
			const title = el.querySelector('[data-siro-el=MyTaskTitle]');
			return !!(title && title.textContent.toLowerCase().includes(q));
		},

		hasMatchingMyTasks() {
			return Array.from(document.querySelectorAll('[data-siro-el=MyTaskItem]'))
				.some((el) => this.taskMatches(el));
		},
	}));

	Alpine.data('taskAssignees', (initial = []) => ({
		assignees: Array.isArray(initial) ? [...initial] : [],

		toggle(id) {
			const i = this.assignees.indexOf(id);
			if (i >= 0) this.assignees.splice(i, 1);
			else this.assignees.push(id);
		},

		selected(id) {
			return this.assignees.includes(id);
		},

		chipClass(id) {
			return this.selected(id)
				? 'task-assignee--on'
				: 'task-assignee--off';
		},
	}));

	Alpine.data('commentEdit', (content = '') => ({
		editing: false,
		content,
	}));
});
